<!-- Text Button -->
<div id="button" class="w-100">
  <button class="primary-button" [type]="button.type" [disabled]="button.disabled" (click)="onClickbutton($event)">{{button.label}}</button>
</div>

<!-- Image Button -->
